/**
 * SETORES DA SERCAMP — a lista fixa que a Qualidade conhece.
 *
 * Vale para o campo "Departamento/Setor" de todas as abas e, no cadastro de
 * documentos, entra SEMPRE na lista, somada aos departamentos do RH: um setor
 * existe mesmo sem nenhum colaborador (ativo ou não) cadastrado nele. Antes a
 * lista do documento era só o que o RH tinha, e RH e Qualidade sumiam quando
 * ninguém estava cadastrado neles — e sem o setor o documento não entra.
 *
 * O servidor importa este arquivo (server/documentos-config.ts); por isso ele
 * não tem imports. Para incluir ou tirar um setor, é só aqui.
 */
export const SETORES_FIXOS = [
  "Administrativo",
  "Almoxarifado",
  "Análise de Óleo",
  "Comercial",
  "Diretoria",
  "Engenharia",
  "Financeiro",
  "Manutenção",
  "Montagem",
  "Planejamento",
  "Qualidade",
  "Reforma",
  "RH",
  "SPDA",
];
